import React from "react";

interface ISVGProps {
  width?: number;
  height?: number;
  fill?: string;
}

const AccordionTitleIcon: React.FC<ISVGProps> = ({
  width = 22,
  height = 25,
  fill = "#200E32",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 25 26"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3207 1.67932C18.5722 1.67932 23.6414 6.74854 23.6414 13C23.6414 19.2515 18.5722 24.3207 12.3207 24.3207C6.068 24.3207 1 19.2515 1 13C1 6.74854 6.068 1.67932 12.3207 1.67932Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.8385 14.4652C6.02953 14.4652 5.37231 13.808 5.37231 13.0002C5.37231 12.1925 6.02953 11.5341 6.8385 11.5341C7.64747 11.5341 8.30468 12.1925 8.30468 13.0002C8.30468 13.808 7.64747 14.4652 6.8385 14.4652Z"
        fill={fill}
      />
      <path
        d="M12.3207 14.4652C11.5117 14.4652 10.8545 13.808 10.8545 13.0002C10.8545 12.1925 11.5117 11.5341 12.3207 11.5341C13.1296 11.5341 13.7869 12.1925 13.7869 13.0002C13.7869 13.808 13.1296 14.4652 12.3207 14.4652Z"
        fill={fill}
      />
      <path
        d="M17.8024 14.4652C16.9934 14.4652 16.3362 13.808 16.3362 13.0002C16.3362 12.1925 16.9934 11.5341 17.8024 11.5341C18.6113 11.5341 19.2685 12.1925 19.2685 13.0002C19.2685 13.808 18.6113 14.4652 17.8024 14.4652Z"
        fill={fill}
      />
    </svg>
  );
};

export default AccordionTitleIcon;
